import Vue from 'vue';
import VueI18n from 'vue-i18n';

// translations
import pl from './pl';
import en from './en';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    pl,
    en,
  },
});

export default i18n;
